mutation UPDATE_TEAM_MEMBER (
  $id: UUID!,
  $email: String!,
  $facilityIds: [UUID]!,
  $firstName: String!,
  $lastName: String,
  $phone: String!,
  $role: String!
  $status: String,
) {
  updateTeamMember(
    id: $id,
    email: $email,
    facilityIds: $facilityIds,
    firstName: $firstName,
    lastName: $lastName,
    phone: $phone,
    role: $role,
    status: $status
  ) {
    success
    error
    teamMember {
      phone
      role
      firstName
      lastName
      email
      phone
      id
    }
  }
}
